import {getViewModel} from '@netx/core/lib/utils';

/**
 * DAM-15256 - don't allow deletion of three specific actions,
 * adbuiler, contact, and assets links
 * @method
 * @returns {boolean}
 */
export const cmsActionDeletable = (v) => {
	const model = getViewModel(v);
	if (!model) return false;

	switch (model.get('event')) {
		case 'cms:route:category:root':
		case 'adBuilder:templates:route':
		case 'app:contact':
			return false;
		default:
			return true;
	}
};
